<template>
    <div class="col-12 mt-4">
        <div class="card shadow-sm border-0" style="border-radius: 15px;">
            <div class="card-body p-0">
                <div class="p-4 bg-light-soft d-flex justify-content-between align-items-center">
                    <div>
                        <h4 class="m-0 font-weight-bold text-dark">Picos de Asistencia</h4>
                        <p class="text-muted small m-0">Promedio de entrada y salida por día de la semana</p>
                    </div>
                    <div 
                        class="badge px-3 py-2" 
                        :class="checadorEnabled ? 'badge-success' : 'badge-danger'"
                        style="cursor: pointer;"
                        @click="toggleChecador"
                        v-can="'users'"
                    >
                        <i class="fas fa-power-off mr-1"></i>
                        {{ checadorEnabled ? 'Checador Activo' : 'Checador Inactivo' }}
                    </div>
                </div>
                <div class="p-3" v-if="load">
                    <div class="text-center py-5">
                        <i class="fas fa-spinner fa-pulse fa-3x text-teal"></i>
                        <p class="mt-2 text-muted">Analizando tendencias...</p>
                    </div>
                </div>
                <div v-else class="p-1">
                    <highcharts :options="chartOptions"></highcharts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from '../../services/request';
import { mapActions } from 'vuex';

export default {
    name: 'AttendanceChartComponent',
    data() {
        return {
            load: false,
            checadorEnabled: true,
            chartOptions: {
                chart: {
                    type: 'spline',
                    style: {
                        fontFamily: 'Inter, sans-serif'
                    }
                },
                title: { text: null },
                colors: ['#14b8a6', '#f59e0b'], // Teal for entry, Amber for exit
                xAxis: {
                    categories: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
                    gridLineWidth: 0,
                    lineColor: '#e5e7eb'
                },
                yAxis: {
                    title: { text: 'Hora del día' },
                    gridLineDashStyle: 'Dash',
                    gridLineColor: '#f3f4f6',
                    labels: {
                        formatter: function() {
                            const hours = Math.floor(this.value);
                            const minutes = Math.round((this.value - hours) * 60);
                            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                        }
                    },
                    min: 0,
                    max: 24,
                    tickInterval: 3
                },
                tooltip: {
                    shared: true,
                    formatter: function() {
                        let s = `<b>${this.x}</b><br/>`;
                        this.points.forEach(point => {
                            const hours = Math.floor(point.y);
                            const minutes = Math.round((point.y - hours) * 60);
                            const timeStr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                            s += `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${timeStr}</b><br/>`;
                        });
                        return s;
                    }
                },
                plotOptions: {
                    spline: {
                        marker: {
                            radius: 4,
                            lineColor: '#ffffff',
                            lineWidth: 2
                        }
                    }
                },
                series: [
                    { name: 'Entrada Promedio', data: [] },
                    { name: 'Salida Promedio', data: [] }
                ],
                credits: { enabled: false }
            }
        };
    },
    methods: {
        async fetchData() {
            this.load = true;
            try {
                const { data } = await request.get('/attendance/summary');
                
                const entryData = [];
                const exitData = [];

                // Map data translating 08:30 to 8.5
                data.forEach(item => {
                    entryData.push(this.timeToDecimal(item.entry_peak));
                    exitData.push(this.timeToDecimal(item.exit_peak));
                });

                this.chartOptions.series[0].data = entryData;
                this.chartOptions.series[1].data = exitData;
            } catch (error) {
                console.error("Error fetching attendance chart data:", error);
            } finally {
                this.load = false;
            }
        },
        async fetchChecadorStatus() {
            try {
                const { data } = await request.get('/settings/checador');
                this.checadorEnabled = data.enabled;
            } catch (error) {
                console.error("Error fetching checador status:", error);
            }
        },
        async toggleChecador() {
            try {
                const { data } = await request.post('/settings/checador/toggle');
                this.checadorEnabled = data.enabled;
                this.successNotification(data.message);
            } catch (error) {
                this.errorNotification('No se pudo cambiar el estado del checador.');
            }
        },
        timeToDecimal(timeStr) {
            if (!timeStr) return null;
            const [hours, minutes] = timeStr.split(':').map(Number);
            return hours + (minutes / 60);
        },
        ...mapActions({
            successNotification: 'alert/success',
            errorNotification: 'alert/error'
        })
    },
    mounted() {
        this.fetchData();
        this.fetchChecadorStatus();
    }
};
</script>

<style scoped>
.bg-light-soft {
    background-color: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
}
.text-teal { color: #14b8a6; }
</style>
